import EcoImg from 'eco-design/base/eco-img';
import EcoLink from 'eco-design/base/eco-link';
import React, { useState } from 'react';
import styles from './index.module.scss';
import { useLang } from '@/i18n';
import gtm from '@/utils/gtm';
import Anchor from './Anchor';
import EcoTitle from 'eco-design/base/eco-title';
import EcoSpace from 'eco-design/base/eco-space';
import { XStream } from '../icons';
import EcoSection from 'eco-design/base/eco-section';
import useDeviceDetect from '@/utils/hooks/useDeviceDetect';
import useCardsShowHook from '../useHooks/useCardsShowHook';

const KSPPicture: React.FC = () => {
    const { t } = useLang('Delta3AirSeries.G');
    const { isPad, isH5 } = useDeviceDetect();
    useCardsShowHook('.rights-content .item', '.rights-content');
    return (
        <section className={`${styles.G} GtmModuleData-section range4`} id="List-sence-D" data-section-id="D3A-G">
            <EcoSpace />
            <div className="box">
                <EcoSection title={t('title')} desc={t('desc')} />
                <div className="rights-content">
                    <EcoLink className="item item1">
                        <div className="sub-text">
                            <div className="item-title">
                                {<XStream color={isPad || isH5 ? 'black' : 'white'} />}
                                {t('item1')}
                            </div>
                        </div>
                        <EcoImg
                            className="item-img"
                            pc="https://websiteoss.ecoflow.com/upload/image/1763522337427/1.jpg"
                            h5="https://websiteoss.ecoflow.com/upload/image/1763522344641/m-1.jpg"
                            isOpenLazy
                        ></EcoImg>
                    </EcoLink>

                    <EcoLink className="item item2">
                        <EcoImg
                            className="item-img"
                            pc="https://websiteoss.ecoflow.com/upload/image/1763522337636/2.jpg"
                            h5="https://websiteoss.ecoflow.com/upload/image/1763522344970/m-2.jpg"
                            isOpenLazy
                        ></EcoImg>
                        <div className="sub-text">
                            <div className="item-title">{t('item2')}</div>
                        </div>
                    </EcoLink>

                    <EcoLink className="item item3">
                        <EcoImg
                            className="item-img"
                            pc="https://websiteoss.ecoflow.com/upload/image/1763522338054/3.jpg"
                            h5="https://websiteoss.ecoflow.com/upload/image/1763522345249/m-3.jpg"
                            isOpenLazy
                        ></EcoImg>
                        <div className="sub-text">
                            <div className="item-title">{t('item3')}</div>
                        </div>
                    </EcoLink>

                    <EcoLink className="item item4">
                        <EcoImg
                            className="item-img"
                            pc="https://websiteoss.ecoflow.com/upload/image/1763522338526/4.jpg"
                            h5="https://websiteoss.ecoflow.com/upload/image/1763522445608/m-4.jpg"
                            isOpenLazy
                        ></EcoImg>
                        <div className="sub-text">
                            <div className="item-title">{t('item4')}</div>
                        </div>
                    </EcoLink>
                </div>
            </div>
            <EcoSpace />
        </section>
    );
};

export default KSPPicture;
